export default __webpack_public_path__ + "static/hero_fund-6caf04137e5cb2de3f19c7b874b1c3b0.jpg";